// @ts-check
import React, { useState } from 'react'
import { useStore } from '../../../StateProvider'
import { map } from 'ramda'
import { useResidenceDependentVisibility } from '../../utils/hooks'
import { ExternalPurposeAccountDependentField } from '..'

const residenceDependentFields = ['bankName']

/**
 * @param {{
  * i18n: string,
  * name: string,
  * requiredForCountries?: string[]
  * allowNonLatin: boolean
  * }} props
  */
const ExternalPurposeAccountCountryDependent = ({
  i18n,
  name,
  requiredForCountries,
  allowNonLatin
}) => {
  const [isShown, setIsShown] = useState(
    !requiredForCountries ||
    !requiredForCountries.length ||
    !residenceDependentFields.includes(name)
  )
  const [{ form, form: { accId } }, dispatch] = useStore()
  const { residenceCountry } = form[accId]

  const onHide = () => {
    setIsShown(false)
    dispatch({ type: 'removeValidationFld', name })
  }

  const onShow = () => {
    setIsShown(true)
    dispatch({ type: 'addValidationFld', name })
  }

  useResidenceDependentVisibility({
    residenceCountry, requiredForCountries, name, residenceDependentFields, onHide, onShow
  })

  return isShown ? (
    <ExternalPurposeAccountDependentField
      label={i18n ? `generatedField.${i18n}` : ''}
      name={name}
      allowNonLatin={allowNonLatin}
    />
  ) : null
}

const getExternalPurposeAccountCountryDependentFields = map(field => {
  return (
    <ExternalPurposeAccountCountryDependent {...field} />
  )
})

export { ExternalPurposeAccountCountryDependent, getExternalPurposeAccountCountryDependentFields }
